import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  robots,
  author,
  publisher,
  schema,
  ogTitle,
  ogDescription,
  ogImage,
  twitterTitle,
  twitterDescription,
}) {
  const location = useLocation();
  const defaultOgImage = "https://pranaamhospitals.com/images/pranaam-logo.png";
  const finalOgImage = ogImage || defaultOgImage;

  return (
    <Helmet key={location.pathname}>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      {robots && <meta
  name="robots"
  content={
    robots === "index" || robots === "INDEX"
      ? "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
      : robots || "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1"
  }
/>}
      {author && <meta name="author" content={author} />}
      {publisher && <meta name="publisher" content={publisher} />}

      {/* Open Graph */}
      {(ogTitle || title) && <meta property="og:title" content={ogTitle || title} />}
      {(ogDescription || description) && <meta property="og:description" content={ogDescription || description} />}
      <meta property="og:image" content={finalOgImage} />
      {canonical && <meta property="og:url" content={canonical} />}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Pranaam Hospitals" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      {(twitterTitle || ogTitle || title) && <meta name="twitter:title" content={twitterTitle || ogTitle || title} />}
      {(twitterDescription || ogDescription || description) && <meta name="twitter:description" content={twitterDescription || ogDescription || description} />}
      <meta name="twitter:image" content={finalOgImage} />

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
}
